import { getAppContext } from '@b2ag/micro-front-tools'
import { useStore } from 'vuex'
import { PAGE_TYPE, PAGE_ANALYTICS_INFO } from '../page-types'
import { isAladin } from '@b2ag/app-brands'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from 'vue-router'

/* ------- MICROFRONT - LEGALS ------- */

export const legalsMainRoutes = [
  {
    path: '/general-conditions-use',
    name: 'legals',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => ({
      microFrontName: 'legals',
      viewName: 'cgu',
    }),
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
      showAppFooter: true,
    },
  },
  {
    path: '/privacy-policy',
    name: 'privacy',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => ({
      microFrontName: 'legals',
      viewName: 'privacy',
    }),
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
      showAppFooter: true,
    },
  },
  {
    path: '/legals',
    name: 'legal-notice',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => ({
      microFrontName: 'legals',
      viewName: 'legal-notice',
    }),
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
      showAppFooter: true,
    },
  },
  {
    path: '/general-terms-and-conditions',
    name: 'cgv',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => {
      return {
        microFrontName: 'legals',
        viewName: 'cgv',
        cooperativeId: useStore().getters.currentCooperativeId,
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
      showAppFooter: true,
      private: isAladin && getAppContext().isFrontAgri,
    },
  },
]

export const legalsTechRoutes = [
  {
    path: '/accept-gcu',
    name: 'accept-cgu-tech',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => ({
      microFrontName: 'legals',
      viewName: 'accept-cgu',
    }),
    beforeEnter(_to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
      if (useStore()?.getters.isCGUAccepted) {
        next({ name: 'home' })
      } else {
        next()
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CGU,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.CGU,
      layout: 'minimal',
    },
  },
]
